module.exports = __webpack_public_path__ + "static/media/app-logo.4b82756e.svg";